// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import Ractive from 'ractive';
Ractive.DEBUG = false;
window.Ractive = Ractive;
